import React from 'react'
import { useSelector } from 'react-redux'

import { translate } from '~/core/translate'
import { getDialogProps, getViewedSessionId } from '~/selectors/ui'
import { getSessionActionItems } from '~/selectors/session-details'
import Modal from '~/components/common/modal'
import AiBadge from '~/components/common/ai-badge'

const ActionItemsDialog = () => {
  const id = useSelector(getDialogProps).id ?? useSelector(getViewedSessionId)
  const actionItems = useSelector(getSessionActionItems(id))

  return (
    <Modal
      title={translate('meeting_action_items')}
      titleBadge={<AiBadge />}
    >
      {actionItems.map(text => <p key={text}>{text}</p>)}
    </Modal>
  )
}

export default ActionItemsDialog
